import React, { Component } from "react"; import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import axios from "axios";
import * as moment from "moment";
import {connect}  from  "react-redux";

class InternalReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray: [],
            acq_fall_last_updated: '',
            speed_last_updated: '',
            connectivity_last_updated: '',
            iss_speed_last_updated: '',
            acq_speed_last_updated: '',
            edc_health_last_updated: '',
            emi_sc_last_updated: '',
        }
    }
  componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let MenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if (permissionName.access_type == 'Menu') {
                MenuPermissions.push(permissionName.access_name);
            }
            if (permissionName.access_type == 'report') {
                reportPermissions.push(permissionName.access_name);
            }
        });
        if (MenuPermissions.includes("internal_report") === false) {
            this.unauthorize_access();
        }
        this.setState({
            reportPermissionsArray: reportPermissions,
            user_id: decoded._id
        });
        this.get_last_update_acq_fall_back();
        this.get_last_update_speed_rel();
        this.get_last_update_connectivity();
        this.get_last_update_issuer_speed();
        this.get_last_update_acquirer_speed();
        this.get_last_update_edc_health();
        //this.get_last_update_emi_scheme();
    }
    unauthorize_access() {
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    get_last_update_acq_fall_back() {
        axios.get(config.get('API_URL') + '/reports/fall-back-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                acq_fall_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_speed_rel() {
        axios.get(config.get('API_URL') + '/reports/speed-reliability-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_connectivity() {
        axios.get(config.get('API_URL') + '/reports/connectivity-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                connectivity_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_issuer_speed() {
        axios.get(config.get('API_URL') + '/reports/issuer-speed-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                iss_speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_acquirer_speed() {
        axios.get(config.get('API_URL') + '/reports/acquirer-speed-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                acq_speed_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_edc_health() {
        axios.get(config.get('API_URL') + '/reports/fall-back-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                edc_health_last_updated: response.data[0].start_time
            })
        });
    }
    get_last_update_emi_scheme() {
        axios.get(config.get('API_URL') + '/reports/emi-scheme-update/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            this.setState({
                emi_sc_last_updated: response.data[0].start_time
            })
        });
    }
    render() {
        return (

                    <div className="content-invoice">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 pt-5">
                                    <div className="">
                                        <div className="content">
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="card title-card-bottom-space">
                                                        <div className="header">
                                                            <h4 className="title">Internal Tools</h4>
                                                            <p className="category"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="content">
                                            <div className="row">

                                                {this.state.reportPermissionsArray.includes("edc_health") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/edc-health-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>EDC Health Report</h5>
                                                                        <p className="text-muted">Last updated : {this.state.edc_health_last_updated != '' ? moment(this.state.edc_health_last_updated).format('D MMM YYYY HH:mm:ss') : null}</p>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("user_login") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/login-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Login Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}


                                                {this.state.reportPermissionsArray.includes("bounce_back_indicator_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/bounce-back-indicator-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Bounce Back Indicator Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                {this.state.reportPermissionsArray.includes("okr_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/okr-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>OKR Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {this.state.reportPermissionsArray.includes("innoviti_business_snapshot_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/innoviti-business-snapshot-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Innoviti Business Snapshot </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                {this.state.reportPermissionsArray.includes("poser_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/poser-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>POSER Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("stellr_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/stellr-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Stellr Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("idownload_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/i-download/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>iDownload Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("binmanager_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/bin-manager-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>BinManager Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("product_error_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/product-error-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Product Error Report </h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("adani_gas_station_daily_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/adani-gas-station-daily-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Adani Gas station daily report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                    {this.state.reportPermissionsArray.includes("transaction_dump_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/live-txn-dump-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Transaction Dump report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("product_error_heatmap_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/heat-map/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Product Error Heatmap report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                    {this.state.reportPermissionsArray.includes("genie_acquisition_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/genie-acquisition-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>Genie Acquisition Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("ubc_txn_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/ubc-txn-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>UBC Transaction Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("GRD_dump_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/grd-dump-report/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>GRD Dump Report</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("genie_roi") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/genie-roi/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>GENIE ROI</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}

                                                    {this.state.reportPermissionsArray.includes("failed_upi_txn_to_eft_report") === true ?
                                                    <div className="col-lg-3 col-xs-6">
                                                        <div className="card report-dash">
                                                            <div className="content text-center">
                                                                <Link className="" to="/admin/failed-upi-txn-to-eft/">
                                                                    <div className="report-thumbs-ico">
                                                                        <div className="icon-big text-center folder-icon">
                                                                            <i className="fa fa-folder-o"></i>
                                                                        </div>
                                                                        <h5>FAILED UPI Transaction TO EFT</h5>
                                                                        {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div> : null}


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(InternalReport);